import React from "react";

const OrganicProducts = () => {
  return (
    <div className="nailExtensionMaintain">
      <h5>Organic Products We Use</h5>
      <p>
        At SCENT , we carefully select the best organic products for our
        manicure services. Here are some of the key products we use:
      </p>
      <ul>
        <li>
          <h6>Organic Nail Polishes: </h6>Our polishes are free from toxic
          chemicals and come in a variety of vibrant colors. Brands we use
          include Zoya, Priti NYC, and Butter London, known for their
          high-quality, eco-friendly formulations.
        </li>
        <li>
          <h6>Organic Exfoliants: </h6>We use natural scrubs made from
          ingredients like sugar, salt, and essential oils. These exfoliants
          gently remove dead skin cells and reveal softer, smoother skin.
        </li>
        <li>
          <h6>Organic Lotions: </h6> Our hand lotions are made from nourishing
          ingredients like shea butter, coconut oil, and aloe vera. They hydrate
          and soothe your skin, leaving it feeling soft and refreshed.
        </li>
        <li>
          <h6>Organic Cuticle Oils: </h6>To care for your cuticles, we use oils
          enriched with vitamins and natural extracts. These oils strengthen and
          moisturize your cuticles, promoting healthy nail growth.
        </li>
      </ul>
    </div>
  );
};

export default OrganicProducts;
